/**
 * Signup Context API — Epic 14: DKI Personalized Registration
 *
 * Returns the signup intent and qualification data stored on the Tenant.
 * Used by dashboard onboarding to auto-select the right path.
 */
import { getCPToken, cpGuestApiCall } from './controlPlaneClient'

export interface SignupContextResponse {
  signup_intent: string | null
  signup_qualification: Record<string, unknown> | null
  signup_conversion_value: number | null
  onboarding_completed: boolean
}

export async function cpCompleteOnboarding(): Promise<{ success: boolean }> {
  const token = getCPToken()
  return cpGuestApiCall<{ success: boolean }>('control_plane.api.tenant.complete_onboarding', {
    method: 'POST',
    body: JSON.stringify({ access_token: token }),
  })
}

export async function cpGetSignupContext(): Promise<SignupContextResponse> {
  const token = getCPToken()
  return cpGuestApiCall<SignupContextResponse>('control_plane.api.tenant.get_signup_context', {
    method: 'POST',
    body: JSON.stringify({ access_token: token }),
  })
}
